import { WorkRequirementNextStepsScreen } from "@/interactors/WorkRequirementNextStepsScreen";

export default function WorkRequirementNextSteps() {
  return <WorkRequirementNextStepsScreen />;
}
